import { Row } from 'antd'
import Table from 'app/components/Core/Rental/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  project: IProject
}

const Rental: React.FC<Props> = ({ project }) => {
  const navigate = useNavigate()

  return (
    <Row gutter={[{ xs: 0, md: 12 }, 12]}>
      <KCol card span={24} loading={!project}>
        <If condition={project}>
          <Table
            onRowClick={(rental) => navigate(Routes.Rental.member(rental.id.toString()).show)}
            params={{ projectId: project.id, isRequested: true }}
          />
        </If>
      </KCol>
    </Row>
  )
}

export default Rental
